export default __webpack_public_path__ + "static/media/ceo.37562d7c.png";